// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"f65018fe","513":"88570f44","558":"0fccb73a","787":"2ad53b11","993":"250a135d"}[chunkId] + ".chunk.js";
};